export default __webpack_public_path__ + "static/media/SAS0270.34I-39284_-25300_0.077f608b.jpg";